export default __webpack_public_path__ + "static/media/Neovera-6-eng.16503efd.jpg";